<template>
    <section>

        <h1>Test</h1>
        <router-link
            tag="a"
            ref="link"
            :to="{name: 'register'}"
            class="text-primary"
        >регистрацию</router-link>

        <h1>Colors</h1>
        <span class="bg-primary text-white"> #3577D3 </span>
        <h1>Fonts</h1>
        <h1>H1</h1>
        <h1>Geometria Medium 36 px</h1>
        <h2>H2</h2>
        <h2>Geometria Bold 32 px</h2>
        <h3>H3</h3>
        <h3>Geometria Medium 30 px</h3>
        <h4>H4</h4>
        <h4>Geometria Medium 25 px</h4>
        <h5>H5</h5>
        <h5>Geometria Bold 24 px</h5>
        <h6>H6</h6>
        <h6>Geometria Regular 24 px</h6>
        <span>Base font size - Geometria Regular 20 px</span>

        <h1>Buttons</h1>
        <div class="mb-3">большая кнопка</div>
        <div class="mb-3">
            <button type="button" class="btn btn-primary btn-lg btn--invite">
                Пригласить священника
                <svgButtonArrow cssClass="icon-svg--invite" />
            </button>
        </div>
        <div class="mb-3">обычная кнопка</div>
        <div class="mb-3">
            <button type="button" class="btn btn-primary">Подтвердить</button>
        </div>
        <div class="mb-3">
            <button type="button" class="btn btn-outline-primary">Выполнено</button>
        </div>
        <div class="mb-3">
            <button type="button" class="btn btn-primary">Добавить в мои обращения</button>
        </div>
        <div class="mb-3 p-5" style='background: transparent url("images/back1.png")'>
            <button type="button" class="btn btn-transparent btn--me-priest">
                <svgMePriest />
                Я - священник
            </button>
        </div>

        <h1>Links</h1>
        <div class="mb-3">
            <a class="a--primary" href="#"><svgArrowBack class="mr-4" /><span>Вернуться назад</span></a>
        </div>
        <div class="mb-3">
            <a class="a--primary a--underlined" href="#"><svgDocument class="mr-2" /><span>Запросить документы</span></a>
        </div>
        <div class="mb-3">
            <a class="a--underlined" href="#"><span>Выход</span></a>
        </div>
        <div class="mb-3">
            <a class="a--sm" href="#"><span>Связаться с нами</span></a>
        </div>
        <div class="mb-3">
            <a class="a--sm" href="#"><span>Вход</span></a>
        </div>

        <h1>Forms</h1>
        <form>
            <div class="form-group">
                <label for="t1">Вашне имя</label>
                <input type="text" class="form-control" id="t1" placeholder="Февроний">
            </div>
            <div class="form-group">
                <label for="t2">Вашне имя</label>
                <textarea class="form-control" id="t2" placeholder="Февроний"></textarea>
            </div>
            <div class="form-group has-error">
                <label for="t3">Вашне имя</label>
                <input type="text" class="form-control" id="t1" placeholder="Февроний" invalid="invalid">
                <small class="form-text text-muted">*Некорректные символы</small>
            </div>
        </form>

        <h1>Icons</h1>
        <div class="mb-3"><svgButtonArrow /></div>
        <div class="mb-3"><svgClose /></div>
        <div class="mb-3"><svgArrowUp /></div>
        <div class="mb-3"><svgArrowUp class="icon-svg--reverse-ver" /></div>
        <div class="mb-3"><svgArrowBack /></div>
        <div class="mb-3"><svgArrowBack class="icon-svg--reverse-hor" /></div>
        <div class="mb-3"><svgDocument /></div>
        <div class="mb-3"><svgMePriest /></div>

    </section>
</template>

<script>
import svgButtonArrow from '../../icons/buttonarrow'
import svgClose from '../../icons/close'
import svgArrowUp from '../../icons/arrowup'
import svgArrowBack from '../../icons/arrowback'
import svgDocument from '../../icons/document'
import svgMePriest from '../../icons/mepriest'

export default {

    components: {
        svgButtonArrow,
        svgClose,
        svgArrowUp,
        svgArrowBack,
        svgDocument,
        svgMePriest,
    },

}
</script>

<style lang="scss">

</style>
